// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__1Hqts","button":"style_button__2qNs4","copied":"style_copied__1crrM","ready":"style_ready__18pc6"};